// Экран блокировки и заставка. Заставка (saver) включается сама после простоя: часы и фотографии, закрывается любым движением мыши
// или нажатием, без кода. Блокировка (locked) — только когда нажали «Заблокировать экран»: нужен ПИН-код. Выбор сотрудника в меню
// профиля (switching) тоже просит его ПИН-код.
// Блокировка хранится в localStorage: после перезагрузки страницы и в других вкладках экран остаётся заблокированным.
// Открыть экран блокировки можно без потери сессии — вход прежнего пользователя продолжает действовать, пока не введён ПИН-код.
import Vue from 'vue'
import { isAuthenticated } from './auth'

// Через сколько бездействия включается заставка
export const IDLE_LOCK_MS = 30 * 60 * 1000

const LOCK_KEY = 'app_locked'
const ACTIVITY_KEY = 'app_last_activity'
// Как часто проверять, не пора ли блокировать, и как часто записывать активность (для других вкладок)
const CHECK_MS = 5 * 1000
const ACTIVITY_WRITE_MS = 5 * 1000

function read(key) {
  try {
    return localStorage.getItem(key)
  } catch (e) {
    return null
  }
}

function write(key, value) {
  try {
    localStorage.setItem(key, value)
  } catch (e) {
    // localStorage недоступен — блокировка работает только в этой вкладке
  }
}

function remove(key) {
  try {
    localStorage.removeItem(key)
  } catch (e) {
    // ничего
  }
}

// saver — заставка по простою (закрывается без кода);
// locked — экран заблокирован (закрыть его без ПИН-кода нельзя);
// switching — открыт выбор пользователя из рабочего экрана: его можно отменить
// pick — пользователь, выбранный в меню профиля: на экране ввода ПИН-кода подходит только его код
export const lockState = Vue.observable({ locked: read(LOCK_KEY) === '1', switching: false, pick: null, saver: false })

let lastActivity = Date.now()
let lastWrite = 0
let timer = null
let watching = false

const EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'wheel', 'scroll']

export function lockNow() {
  if (!isAuthenticated()) return
  lockState.saver = false
  lockState.switching = false
  lockState.pick = null
  lockState.locked = true
  write(LOCK_KEY, '1')
}

// Заставка по простою: любому пользователю, код не нужен
export function showSaver() {
  if (!isAuthenticated() || lockState.locked || lockState.switching) return
  lockState.saver = true
}

export function dismissSaver() {
  lockState.saver = false
  touch()
}

export function unlock() {
  lockState.saver = false
  lockState.locked = false
  lockState.switching = false
  lockState.pick = null
  remove(LOCK_KEY)
  touch()
}

// Смена пользователя из рабочего экрана: выбранный в меню пользователь вводит свой ПИН-код
export function openSwitch(user) {
  if (!isAuthenticated()) return
  lockState.pick = user || null
  lockState.switching = true
}

export function closeSwitch() {
  lockState.switching = false
  lockState.pick = null
}

function touch() {
  const now = Date.now()
  lastActivity = now
  if (now - lastWrite >= ACTIVITY_WRITE_MS) {
    lastWrite = now
    write(ACTIVITY_KEY, String(now))
  }
}

function check() {
  if (lockState.locked || lockState.saver || !isAuthenticated()) return
  // активность в другой вкладке тоже считается: человек работает, просто не в этой вкладке
  const other = parseInt(read(ACTIVITY_KEY) || '0', 10)
  const last = Math.max(lastActivity, isNaN(other) ? 0 : other)
  if (Date.now() - last >= IDLE_LOCK_MS) showSaver()
}

// Вкладка вернулась из фона (или компьютер проснулся): браузер притормаживает таймеры скрытых вкладок, поэтому
// время бездействия проверяется сразу, до первого движения мыши, — заставка включается без задержки
function onVisible() {
  if (!document.hidden) check()
}

function onStorage(e) {
  if (e.key === LOCK_KEY) lockState.locked = e.newValue === '1'
}

// Включить слежение за бездействием (вызывается оболочкой приложения после входа)
export function startIdleWatch() {
  if (watching) return
  watching = true
  lastActivity = Date.now()
  EVENTS.forEach((name) => window.addEventListener(name, touch, { passive: true, capture: true }))
  window.addEventListener('storage', onStorage)
  window.addEventListener('focus', onVisible)
  document.addEventListener('visibilitychange', onVisible)
  timer = setInterval(check, CHECK_MS)
  // Страница открылась уже заблокированной: актуальное состояние берём из хранилища
  lockState.locked = read(LOCK_KEY) === '1'
}

export function stopIdleWatch() {
  if (!watching) return
  watching = false
  EVENTS.forEach((name) => window.removeEventListener(name, touch, { passive: true, capture: true }))
  window.removeEventListener('storage', onStorage)
  window.removeEventListener('focus', onVisible)
  document.removeEventListener('visibilitychange', onVisible)
  clearInterval(timer)
  timer = null
}
